export const toastConstants = {
  SUCCESS_TIMEOUT: 5000,
  INFO_TIMEOUT: 8000,
  ERROR_TIMEOUT: 10000,
  WARNING_TIMEOUT: 10000,
  NOTICE_TIMEOUT: 20000,
};
